import React, { useState } from 'react';
import Modal from 'react-modal';
import { Button, Grid, makeStyles } from '@material-ui/core';
import CustomRange from '../report/CustomRange';
import Theme from '../ui/Theme';

const customStyles = {
  overlay: {
    backgroundColor: 'hsla(50, 33%, 25%, 0.35)',
    zIndex: 1,
  },
  content: {
    display: 'flex',
    padding: '20px 16px 28px',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '350px',
    height: '520px',
    background: '#FFFFFF',
    zIndex: 1,
    borderRadius: '8px',
  },
};

const useStyles = makeStyles(() => ({
  doneButton: {
    width: '100%',
    height: '42px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  frame34: {
    marginLeft: '16px',
    marginTop: '10px',
    marginBottom: '20px',
  },
  title: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    alignItems: 'center',
    color: 'black',
  },
}));

export function CustomDatePopup({ handleRangeSelection, setIsOpenCalendar, setAppliedFilters }) {
  const classes = useStyles();

  const [isOpen, setIsOpen] = useState(true);
  const [range, setRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  });

  const handleSubmit = () => {
    setIsOpen(false);
    handleRangeSelection(range);
    setIsOpenCalendar(false);
  };

  const handleClose = () => {
    setIsOpen(false);
    setIsOpenCalendar(false);
    setAppliedFilters((pre) => ({
      ...pre,
      timePeriod: 0,
    }));
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={handleClose} shouldCloseOnEsc={false} style={customStyles}>
      <Grid container direction="column">
        <Grid item className={classes.frame34}>
          <div className={classes.title}> Select Range</div>
        </Grid>
        <Grid item>
          <CustomRange selectionRange={range} handleSelect={(ranges) => setRange(ranges.selection)} />
        </Grid>
        <Grid item style={{ marginTop: '40px' }}>
          <Button
            color="primary"
            variant="contained"
            disableElevation
            className={classes.doneButton}
            onClick={handleSubmit}
          >
            Done
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
}
